import type { TFunction } from "i18next";
import { getStatusHumanLabel } from "../../../../../../utils/getStatusEntity";

/**
 * Get the appropriate color classes for a trailer status
 */
export const getStatusColor = (status: { id: string; name: string }): string => {
  if (!status) return "text-gray-500 bg-gray-500/10";
  switch (status.name) {
    case "ACTIVE":
      return "text-[#3FBF1D] bg-[#C7FFB5]";
    case "INACTIVE":
      return "text-red-500 bg-red-500/10";
    case "MAINTENANCE":
      return "text-amber-500 bg-amber-500/10";
    case "OUT_OF_SERVICE":
      return "text-gray-500 bg-gray-500/10";
    default:
      return "text-gray-500 bg-gray-500/10";
  }
};

/**
 * Get the translated label for a trailer status
 */
export const getStatusLabel = (status: { id: string; name: string }, t?: TFunction): string => {
  if (!status) return t ? t("units.status.unknown") : "Desconocido";
  return getStatusHumanLabel(status.name, t);
};

/**
 * Get the translated label for a trailer type
 */
export const getTypeLabel = (type: string): string => {
  switch (type) {
    case "dry_van":
      return "Caja Seca";
    case "refrigerated":
      return "Refrigerado";
    case "flatbed":
      return "Plataforma";
    case "tank":
      return "Tanque";
    case "lowboy":
      return "Lowboy";
    case "container":
      return "Portacontenedor";
    case "dump":
      return "Volteo";
    case "car_carrier":
      return "Porta Vehículos";
    case "all":
      return "Todos";
    default:
      return type;
  }
};

/**
 * Get the translated label for a trailer condition
 */
export const getConditionLabel = (condition: string): string => {
  switch (condition) {
    case "excellent":
      return "Excelente";
    case "good":
      return "Buena";
    case "fair":
      return "Regular";
    case "poor":
      return "Mala";
    default:
      return condition;
  }
};

/**
 * Get the translated label for brake type
 */
export const getBrakeTypeLabel = (brakeType: string): string => {
  switch (brakeType) {
    case "air":
      return "Neumáticos";
    case "hydraulic":
      return "Hidráulicos";
    case "electric":
      return "Eléctricos";
    case "abs":
      return "ABS";
    default:
      return brakeType;
  }
};

/**
 * Get the translated label for suspension type
 */
export const getSuspensionTypeLabel = (suspensionType: string): string => {
  switch (suspensionType) {
    case "air":
      return "Neumática";
    case "spring":
      return "Muelles";
    case "mechanical":
      return "Mecánica";
    default:
      return suspensionType;
  }
};

